import React from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogActions, DialogContent, IconButton } from "@mui/material";
import { Clear } from "@mui/icons-material";
import { Translate } from "orion-components/i18n";

const ImagePreviewDialog = ({ open, onClose, src, filename, showDownload }) => {
	return (
		<Dialog open={open} maxWidth="lg" onClose={onClose} data-testid="orion-components-cbcomponents-cbfile-link-image-preview-dialog-dialog">
			<DialogActions data-testid="orion-components-cbcomponents-cbfile-link-image-preview-dialog-dialog-actions">
				<IconButton onClick={onClose} data-testid="orion-components-cbcomponents-cbfile-link-image-preview-dialog-icon-button">
					<Clear />
				</IconButton>
			</DialogActions>
			<DialogContent style={{ overflow: "hidden" }} data-testid="orion-components-cbcomponents-cbfile-link-image-preview-dialog-dialog-content">
				{src && <img alt={filename} src={src} style={{ maxHeight: "80vh", maxWidth: "100%", objectFit: "contain" }} />}
			</DialogContent>
			{showDownload && (
				<DialogActions data-testid="orion-components-cbcomponents-cbfile-link-image-preview-dialog-dialog-actions-2">
					<Button fullWidth color="primary" href={src} download={filename} data-testid="orion-components-cbcomponents-cbfile-link-image-preview-dialog-button">
						<Translate value="global.CBComponents.CBFileLink.downloadImg" />
					</Button>
				</DialogActions>
			)}
		</Dialog>
	);
};

ImagePreviewDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	src: PropTypes.string,
	filename: PropTypes.string,
	showDownload: PropTypes.bool
};

ImagePreviewDialog.defaultProps = {
	open: false,
	onClose: () => {},
	src: "",
	filename: "",
	showDownload: true
};

export default ImagePreviewDialog;
